const supportedFiltersBuilder = (apiSupportedFilters) => {
  return {
    filter: apiSupportedFilters.nameId,
    icon: apiSupportedFilters.iconUrl,
  }
}

export default supportedFiltersBuilder
